import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CsControlsModule } from '@cbuild/controls';
import { StyleDisplayModule } from '../../directives/style-display/style-display.module';
import { TransferCustomerComponent } from './transfer-customer.component';
import { TransferCustomerService } from './transfer-customer.service';

@NgModule({
  declarations: [TransferCustomerComponent],
  imports: [
    CommonModule,
    CsControlsModule,
    ReactiveFormsModule,
    StyleDisplayModule
  ],
  providers: [TransferCustomerService],
  exports: [TransferCustomerComponent]
})
export class TransferCustomerModule {}
